var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudSearch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.5C16.2835 15.5 15.5 16.2835 15.5 17.25C15.5 18.2165 16.2835 19 17.25 19C17.7335 19 18.1699 18.8049 18.4874 18.4874C18.8049 18.1699 19 17.7335 19 17.25C19 16.2835 18.2165 15.5 17.25 15.5ZM14 17.25C14 15.4551 15.4551 14 17.25 14C19.0449 14 20.5 15.4551 20.5 17.25C20.5 17.8754 20.3229 18.4602 20.0166 18.956L21.2803 20.2197C21.5732 20.5126 21.5732 20.9874 21.2803 21.2803C20.9874 21.5732 20.5126 21.5732 20.2197 21.2803L18.956 20.0166C18.4602 20.3229 17.8754 20.5 17.25 20.5C15.4551 20.5 14 19.0449 14 17.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7938 15.8615C21.1999 13.9155 19.3903 12.5 17.25 12.5C14.6266 12.5 12.5 14.6266 12.5 17.25C12.5 18.2749 12.8246 19.2239 13.3766 20H6.28571C3.91878 20 2 18.1038 2 15.7647C2 13.4256 3.91878 11.5294 6.28571 11.5294C6.56983 11.5294 6.8475 11.5567 7.11616 11.6089C6.88706 10.9978 6.7619 10.3369 6.7619 9.64706C6.7619 6.52827 9.32028 4 12.4762 4C15.4159 4 17.8371 6.19371 18.1551 9.01498C20.393 9.78024 22 11.8811 22 14.3529C22 14.8754 21.9282 15.3813 21.7938 15.8615Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSearch1);
export default __webpack_public_path__ + "static/media/cloud-search-1.6ac8d74b445a9b115038f283c862c1a4.svg";
export { ForwardRef as ReactComponent };